import React, { useEffect, useCallback } from "react";
import styled from "styled-components";
import isEmpty from "lodash/isEmpty";
import { Trans, useTranslation } from "react-i18next";
import { LinkContainer, IfPermitted, Spinner } from "components/common";
import { Alert, Button, ButtonToolbar } from "components/bootstrap";
import { useStore } from "stores/connect";
import ForwarderRoutes from "forwarder/Routes";
import InputProfileSwitchForm from "../input-profiles/InputProfileSwitchForm";
import ForwarderInputsManagement from "../inputs-list/ForwarderInputsManagement";
import InputProfilesStore, { InputProfilesActions } from "../stores/InputProfilesStore";
import ForwarderInputsStore, { ForwarderInputsActions } from "../stores/ForwarderInputsStore";
const StyledButton = styled(Button)`
  margin-left: 0.5em;
  vertical-align: baseline;
`;
const ForwarderInputProfile = ({ forwarder, inputProfileId = "", onInputProfileSwitch }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { all: inputProfiles } = useStore(InputProfilesStore);
  const { forwarderInputs, pagination } = useStore(ForwarderInputsStore);
  const _saveForwarderInputProfile = ({ id }) => {
    onInputProfileSwitch(id);
    ForwarderInputsActions.list({ inputProfileId: id });
  };
  const _handleQuery = useCallback(
    (page, pageSize, query = "") => {
      ForwarderInputsActions.list({
        inputProfileId,
        page,
        pageSize,
        query
      });
    },
    [inputProfileId]
  );
  useEffect(() => {
    if (!inputProfiles) {
      InputProfilesActions.listAll();
    }
    if (isEmpty(forwarderInputs) && inputProfileId) {
      ForwarderInputsActions.list({ inputProfileId });
    }
  }, [inputProfileId, inputProfiles, forwarderInputs]);
  if (!inputProfiles) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const inputProfile = inputProfiles.find((i) => i.id === inputProfileId);
  if (!inputProfile) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("forwarder_input_profile.not_configured"), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:edit" }, /* @__PURE__ */ React.createElement(LinkContainer, { to: ForwarderRoutes.configure(forwarder.id) }, /* @__PURE__ */ React.createElement(StyledButton, { bsSize: "xsmall", bsStyle: "primary" }, t("forwarder_input_profile.configure_now")))));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: ForwarderRoutes.PROFILE.details(inputProfile.id) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "default" }, t("forwarder_input_profile.view_input_profile"))), forwarder && inputProfile && inputProfiles && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:edit" }, /* @__PURE__ */ React.createElement(
    InputProfileSwitchForm,
    {
      onSave: _saveForwarderInputProfile,
      forwarder,
      currentInputProfile: inputProfile,
      inputProfiles
    }
  )))), /* @__PURE__ */ React.createElement("h2", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "forwarder_input_profile.heading",
      values: { title: inputProfile.title },
      components: { em: /* @__PURE__ */ React.createElement("em", null) }
    }
  )), forwarderInputs[inputProfileId] && /* @__PURE__ */ React.createElement(
    ForwarderInputsManagement,
    {
      inputs: forwarderInputs[inputProfileId],
      forwarder,
      pagination,
      onQueryChange: _handleQuery,
      inputProfile
    }
  ));
};
export default ForwarderInputProfile;
